export const sort = [
  {
    label: "ID",
    name: "id",
    style: { width: 130 },
  },
  { label: "Nazwa", name: "name" },
  { label: "Label", name: "label", sortable: false },
  { label: "Kraj", name: "country_code" },
  { label: "Waluta", name: "currency_code" },
  { label: "Język", name: "language" },
  { label: "Max. tytuł", name: "offer_title_max_length" },
  { label: "Sklep", name: "shops", sortable: false },
];

export const filters = [
  {
    type: "input",
    name: "name",
    sort_id: "name",
    search_type: "matches",
  },
];
